import { Tooltip as ChakraTooltip, TooltipProps } from "@chakra-ui/react";
import React, { forwardRef } from "react";
import { useColors } from "./useColors";

const TooltipInternal = (
  props: TooltipProps,
  ref: React.ForwardedRef<HTMLDivElement> | null,
) => {
  const { footnoteBackground, textColor } = useColors();
  return (
    <ChakraTooltip
      ref={ref}
      bg={footnoteBackground}
      color={textColor}
      {...props}
    />
  );
};

export const Tooltip = forwardRef(TooltipInternal);
